import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import SwipePage from "./pages/SwipePage";
import AdminPage from "./pages/AdminPage";

// When the service worker is updated, force a single reload so the new bundle
// is actually executed. Without this, Chrome can keep showing the old page
// for users who already had the site cached / added to home screen.
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
    let reloaded = false;
    navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "kw-sw-updated" && !reloaded) {
            reloaded = true;
            window.location.reload();
        }
    });
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<SwipePage />} />
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster theme="dark" position="top-center" richColors />
        </div>
    );
}

export default App;
